import React from 'react';
import PropTypes from 'prop-types';
import { CertificateContainer, EachCertificate } from './UserCert.styles';

const ListOfUserCertificates = ({ user }) => {
  // console.log('User', user);
  return (
    <>
      <h3>List of Certificates</h3>

      <CertificateContainer>
        {user?.completeCourses?.map((c) => {
          // Only return the ones that have complete === true
          return (
            <EachCertificate key={c._id}>
              {c?.certificateUrl ? (
                <iFrame src={c?.certificateUrl} alt={c?.courseName} />
              ) : (
                <div>
                  <h4>Create Certificate</h4>
                </div>
              )}

              <h4>{c?.courseName}</h4>
              <p>Issued on: {new Date(c?.date).toLocaleDateString()}</p>
              {c?.expiryDate && (
                <p
                  style={
                    new Date(c?.expiryDate) <=
                    new Date(new Date().setMonth(new Date().getMonth() + 3))
                      ? { color: 'red' }
                      : {}
                  }
                >
                  Expires on: {new Date(c?.expiryDate).toLocaleDateString()}
                </p>
              )}
            </EachCertificate>
          );
        })}
      </CertificateContainer>
    </>
  );
};
ListOfUserCertificates.propTypes = {
  user: PropTypes.object,
};
export default ListOfUserCertificates;
